<div class="org-page">
  <div class="org-tabs">
    <button class="org-tab" [class.on]="tab==='departments'" (click)="tab='departments'">
      <mat-icon>account_tree</mat-icon> Departments
    </button>
    <button class="org-tab" [class.on]="tab==='teams'" (click)="tab='teams'">
      <mat-icon>groups</mat-icon> Teams
    </button>
  </div>

  <div class="org-body">
    <app-departments *ngIf="tab==='departments'"></app-departments>
    <app-shifts *ngIf="tab==='teams'" embedTab="list"></app-shifts>
  </div>
</div>
